// src/hooks/useRenderEverySecond.ts
'use client'

import { useEffect, useState } from 'react'

// Re-renders the component every second
// Used for always refreshing remaining time on appointment locks
export const useRenderEverySecond = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [time, setTime] = useState(Date.now())

  useEffect(() => {
    const interval = setInterval(() => setTime(Date.now()), 1000)
    return () => {
      clearInterval(interval)
    }
  }, [])
}
